import { render, staticRenderFns } from "./BalanceCoinM.vue?vue&type=template&id=2a2f94b8"
import script from "./BalanceCoinM.vue?vue&type=script&lang=js"
export * from "./BalanceCoinM.vue?vue&type=script&lang=js"
import style0 from "./BalanceCoinM.vue?vue&type=style&index=0&id=2a2f94b8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports